"use client"

import { ToolCall } from "@/components/ai-elements/tool"
import type { ToolRenderProps } from "@/hooks/useToolRenderer"

/**
 * Default renderer for a tool call in the conversation. Thin adapter over the
 * token-driven `ToolCall` primitive; the streaming `status` drives the icon and
 * Spanish status label.
 *
 * @param name - the tool name.
 * @param args - the (streaming) tool input as text.
 * @param status - the tool lifecycle status.
 * @param result - the tool result text, when available.
 */
export function ToolCallDisplay({ name, args, status, result }: ToolRenderProps) {
  return <ToolCall name={name} status={status} input={args} result={result} />
}
